(function () {
  'use strict';

  var DB_NAME = 'PromoXwearLogoDB';
  var DB_VERSION = 1;
  var STORE_NAME = 'logos';
  var LOGO_KEY = 'primary_logo';

  var selectedFile = null;
  var previewUrl = null;

  var productPreviewUrl = null;
  var productPreviewFile = null;
  var cleanedPreviewBlob = null;

  var LOGO_CHOICE_KEY = 'pxw_logo_choice';
  var LOGO_NAME_KEY = 'pxw_logo_name';
  var LOGO_ORDER_KEY = 'pxw_logo_order';
  var LOGO_HELP_KEY = 'pxw_logo_help_note';

  /* =========================================================
     LOGO CHOICE + PRODUCT PREVIEW
     Header upload is stored in IndexedDB/localStorage.
     Cart attachment is handled separately in main-cart.liquid.
     ========================================================= */

  function getLogoChoiceData() {
    return {
      choice: localStorage.getItem(LOGO_CHOICE_KEY) || '',
      logoName: localStorage.getItem(LOGO_NAME_KEY) || '',
      previousOrder: localStorage.getItem(LOGO_ORDER_KEY) || '',
      helpNote: localStorage.getItem(LOGO_HELP_KEY) || ''
    };
  }

  function clearLogoChoiceDetails() {
    localStorage.removeItem(LOGO_NAME_KEY);
    localStorage.removeItem(LOGO_ORDER_KEY);
    localStorage.removeItem(LOGO_HELP_KEY);
  }

  function syncProductLogoProperties() {
    var data = getLogoChoiceData();

    document.querySelectorAll('form.product-form').forEach(function(form) {
      function ensureProperty(name) {
        var selector = 'input[name="properties[' + name + ']"]';
        var input = form.querySelector(selector);

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          form.appendChild(input);
        }

        return input;
      }

      var source = ensureProperty('Logo Source');
      var logoName = ensureProperty('Logo Name');
      var previousOrder = ensureProperty('Previous Order');
      var helpNote = ensureProperty('Logo Help Note');

      if (data.choice === 'uploaded') {
        source.value = 'Uploaded Logo';
        logoName.value = '';
        previousOrder.value = '';
        helpNote.value = '';
      } else if (data.choice === 'on_file') {
        source.value = 'Use Logo on File';
        logoName.value = data.logoName;
        previousOrder.value = data.previousOrder;
        helpNote.value = '';
      } else if (data.choice === 'contact') {
        source.value = 'Contact Me About My Logo';
        logoName.value = '';
        previousOrder.value = '';
        helpNote.value = data.helpNote;
      } else {
        source.value = '';
        logoName.value = '';
        previousOrder.value = '';
        helpNote.value = '';
      }
    });
  }

  function dispatchLogoChoice() {
    var data = getLogoChoiceData();

    document.dispatchEvent(
      new CustomEvent('promox:logo-choice', {
        detail: data
      })
    );

    syncProductLogoProperties();
  }

  function setChoicePanelState(type) {
    var modal = getModal();
    if (!modal) return;

    var onFileButton = modal.querySelector('[data-pxw-logo-on-file]');
    var helpButton = modal.querySelector('[data-pxw-logo-help]');
    var onFilePanel = modal.querySelector('[data-pxw-on-file-panel]');
    var helpPanel = modal.querySelector('[data-pxw-help-panel]');

    var showOnFile = type === 'on_file';
    var showHelp = type === 'contact';

    if (onFilePanel) onFilePanel.hidden = !showOnFile;
    if (helpPanel) helpPanel.hidden = !showHelp;

    if (onFileButton) {
      onFileButton.classList.toggle('is-active', showOnFile);
      onFileButton.setAttribute('aria-expanded', showOnFile ? 'true' : 'false');
    }

    if (helpButton) {
      helpButton.classList.toggle('is-active', showHelp);
      helpButton.setAttribute('aria-expanded', showHelp ? 'true' : 'false');
    }
  }

  /* =========================================================
     INDEXED DB
     ========================================================= */

  function openDB() {
    return new Promise(function(resolve, reject) {
      var request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = function(event) {
        var db = event.target.result;

        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };

      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  async function saveLogo(file) {
    var db = await openDB();

    return new Promise(function(resolve, reject) {
      var tx = db.transaction(STORE_NAME, 'readwrite');
      var store = tx.objectStore(STORE_NAME);

      store.put({
        file: file,
        name: file.name,
        type: file.type,
        size: file.size,
        savedAt: Date.now(),
        rightsConfirmed: true
      }, LOGO_KEY);

      tx.oncomplete = function() {
        resolve();
      };

      tx.onerror = function() {
        reject(tx.error);
      };
    });
  }

  async function getLogo() {
    var db = await openDB();

    return new Promise(function(resolve, reject) {
      var tx = db.transaction(STORE_NAME, 'readonly');
      var store = tx.objectStore(STORE_NAME);
      var request = store.get(LOGO_KEY);

      request.onsuccess = function() {
        resolve(request.result || null);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  async function removeLogo() {
    var db = await openDB();

    return new Promise(function(resolve, reject) {
      var tx = db.transaction(STORE_NAME, 'readwrite');
      var store = tx.objectStore(STORE_NAME);

      store.delete(LOGO_KEY);

      tx.oncomplete = function() {
        resolve();
      };

      tx.onerror = function() {
        reject(tx.error);
      };
    });
  }

  /* =========================================================
     MODAL
     ========================================================= */

  function getModal() {
    return document.querySelector('[data-pxw-logo-modal]');
  }

  function openModal() {
    var modal = getModal();

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    refreshModalState();
  }

  function closeModal() {
    var modal = getModal();

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function makePreview(file) {
    if (!file) return null;

    if (file.type === 'application/pdf') {
      return null;
    }

    return URL.createObjectURL(file);
  }

  /* =========================================================
     HEADER + MOBILE BUTTON
     ========================================================= */

  function updateButtons(logo) {
    document
      .querySelectorAll('[data-pxw-logo-system]')
      .forEach(function(system) {
        var trigger =
          system.querySelector('[data-pxw-open-logo]');

        var empty =
          system.querySelector('[data-pxw-empty-state]');

        var saved =
          system.querySelector('[data-pxw-saved-state]');

        var thumb =
          system.querySelector('[data-pxw-logo-thumb]');

        if (!trigger || !empty || !saved) return;

        if (logo && logo.file) {
          trigger.classList.add('is-saved');

          empty.hidden = true;
          saved.hidden = false;

          if (thumb) {
            var url = makePreview(logo.file);

            if (url) {
              thumb.src = url;
              thumb.style.display = '';
            } else {
              thumb.removeAttribute('src');
              thumb.style.display = 'none';
            }
          }
        } else {
          trigger.classList.remove('is-saved');

          empty.hidden = false;
          saved.hidden = true;

          if (thumb) {
            thumb.removeAttribute('src');
            thumb.style.display = 'none';
          }
        }
      });
  }

  /* =========================================================
     LOAD IMAGE
     ========================================================= */

  function loadImageFromFile(file) {
    return new Promise(function(resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();

      img.onload = function() {
        URL.revokeObjectURL(url);
        resolve(img);
      };

      img.onerror = function() {
        URL.revokeObjectURL(url);

        reject(
          new Error('Could not load logo image')
        );
      };

      img.src = url;
    });
  }

  function isNearTransparent(alpha) {
    return alpha <= 15;
  }

  /* =========================================================
     CLEAN / TRIM PREVIEW LOGO
     ========================================================= */

  async function createCleanPreviewBlob(file) {
    if (!file) return null;

    if (file.type === 'application/pdf') {
      return null;
    }

    if (
      file.type === 'image/svg+xml' ||
      /\.svg$/i.test(file.name || '')
    ) {
      return file;
    }

    var img =
      await loadImageFromFile(file);

    var canvas =
      document.createElement('canvas');

    var ctx =
      canvas.getContext(
        '2d',
        {
          willReadFrequently: true
        }
      );

    var maxSize = 1400;

    var scale =
      Math.min(
        1,
        maxSize / img.naturalWidth,
        maxSize / img.naturalHeight
      );

    var width =
      Math.max(
        1,
        Math.round(
          img.naturalWidth * scale
        )
      );

    var height =
      Math.max(
        1,
        Math.round(
          img.naturalHeight * scale
        )
      );

    canvas.width = width;
    canvas.height = height;

    ctx.clearRect(
      0,
      0,
      width,
      height
    );

    ctx.drawImage(
      img,
      0,
      0,
      width,
      height
    );

    var imageData =
      ctx.getImageData(
        0,
        0,
        width,
        height
      );

    var data =
      imageData.data;

    var edgeLight = 0;
    var edgeTotal = 0;

    function samplePixel(x, y) {
      var index =
        (y * width + x) * 4;

      var r = data[index];
      var g = data[index + 1];
      var b = data[index + 2];
      var a = data[index + 3];

      if (a > 20) {
        edgeTotal++;

        if (
          r >= 238 &&
          g >= 238 &&
          b >= 238
        ) {
          edgeLight++;
        }
      }
    }

    var stepX =
      Math.max(
        1,
        Math.floor(width / 100)
      );

    var stepY =
      Math.max(
        1,
        Math.floor(height / 100)
      );

    var x;
    var y;

    for (
      x = 0;
      x < width;
      x += stepX
    ) {
      samplePixel(x, 0);

      samplePixel(
        x,
        height - 1
      );
    }

    for (
      y = 0;
      y < height;
      y += stepY
    ) {
      samplePixel(0, y);

      samplePixel(
        width - 1,
        y
      );
    }

    var removeLightBackground =
      edgeTotal > 0 &&
      edgeLight / edgeTotal > 0.72;

    if (removeLightBackground) {
      for (
        var i = 0;
        i < data.length;
        i += 4
      ) {
        var r = data[i];
        var g = data[i + 1];
        var b = data[i + 2];
        var a = data[i + 3];

        if (a === 0) continue;

        if (
          r >= 246 &&
          g >= 246 &&
          b >= 246
        ) {
          data[i + 3] = 0;
        }

        else if (
          r >= 236 &&
          g >= 236 &&
          b >= 236
        ) {
          var average =
            (r + g + b) / 3;

          var alphaScale =
            Math.max(
              0,
              Math.min(
                1,
                (246 - average) / 10
              )
            );

          data[i + 3] =
            Math.round(
              a * alphaScale
            );
        }
      }

      ctx.putImageData(
        imageData,
        0,
        0
      );
    }

    var cleaned =
      ctx.getImageData(
        0,
        0,
        width,
        height
      ).data;

    var minX = width;
    var minY = height;
    var maxX = -1;
    var maxY = -1;

    for (
      var py = 0;
      py < height;
      py++
    ) {
      for (
        var px = 0;
        px < width;
        px++
      ) {
        var idx =
          (py * width + px) * 4;

        var alpha =
          cleaned[idx + 3];

        if (
          !isNearTransparent(alpha)
        ) {
          if (px < minX) minX = px;
          if (py < minY) minY = py;

          if (px > maxX) maxX = px;
          if (py > maxY) maxY = py;
        }
      }
    }

    if (
      maxX < minX ||
      maxY < minY
    ) {
      return file;
    }

    var cropWidth =
      maxX - minX + 1;

    var cropHeight =
      maxY - minY + 1;

    var padX =
      Math.max(
        4,
        Math.round(
          cropWidth * 0.035
        )
      );

    var padY =
      Math.max(
        4,
        Math.round(
          cropHeight * 0.035
        )
      );

    minX =
      Math.max(
        0,
        minX - padX
      );

    minY =
      Math.max(
        0,
        minY - padY
      );

    maxX =
      Math.min(
        width - 1,
        maxX + padX
      );

    maxY =
      Math.min(
        height - 1,
        maxY + padY
      );

    cropWidth =
      maxX - minX + 1;

    cropHeight =
      maxY - minY + 1;

    var output =
      document.createElement(
        'canvas'
      );

    output.width =
      cropWidth;

    output.height =
      cropHeight;

    var outputCtx =
      output.getContext('2d');

    outputCtx.clearRect(
      0,
      0,
      cropWidth,
      cropHeight
    );

    outputCtx.drawImage(
      canvas,

      minX,
      minY,
      cropWidth,
      cropHeight,

      0,
      0,
      cropWidth,
      cropHeight
    );

    return new Promise(function(resolve) {
      output.toBlob(
        function(blob) {
          resolve(
            blob || file
          );
        },
        'image/png',
        0.95
      );
    });
  }

  /* =========================================================
     PREPARE CLEAN PRODUCT PREVIEW
     ========================================================= */

  async function prepareProductPreview(file) {
    if (!file) return null;

    if (
      productPreviewFile === file &&
      productPreviewUrl
    ) {
      return productPreviewUrl;
    }

    if (productPreviewUrl) {
      URL.revokeObjectURL(
        productPreviewUrl
      );

      productPreviewUrl = null;
    }

    productPreviewFile = file;
    cleanedPreviewBlob = null;

    try {
      cleanedPreviewBlob =
        await createCleanPreviewBlob(
          file
        );
    } catch (error) {
      console.warn(
        'PromoXwear logo cleaning failed. Using original logo.',
        error
      );

      cleanedPreviewBlob =
        file;
    }

    if (!cleanedPreviewBlob) {
      return null;
    }

    productPreviewUrl =
      URL.createObjectURL(
        cleanedPreviewBlob
      );

    return productPreviewUrl;
  }

  /* =========================================================
     PRODUCT PREVIEW STYLING
     ========================================================= */

  function installProductPreviewStyles() {
    var existing =
      document.getElementById(
        'PromoXLogoProductPreviewStyles'
      );

    if (existing) {
      existing.remove();
    }

    var style =
      document.createElement(
        'style'
      );

    style.id =
      'PromoXLogoProductPreviewStyles';

    style.textContent = `

      [data-pxw-logo-stage] {
        position: relative !important;
        overflow: hidden !important;
      }

      [data-pxw-logo-stage] > .pxw-product-logo-preview {

        position: absolute !important;

        left: 64.5% !important;
        top: 31.5% !important;

        width: 11% !important;

        max-width: 92px !important;
        max-height: 76px !important;

        height: auto !important;

        min-width: 0 !important;
        min-height: 0 !important;

        right: auto !important;
        bottom: auto !important;

        transform:
          translate(-50%, -50%) !important;

        object-fit: contain !important;

        object-position:
          center center !important;

        z-index: 25 !important;

        pointer-events: none !important;

        user-select: none !important;
        -webkit-user-select: none !important;

        opacity: .97 !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;

        box-shadow: none !important;

        filter:
          drop-shadow(
            0 1px 1px rgba(0,0,0,.14)
          ) !important;
      }

      [data-pxw-logo-stage] > .pxw-product-logo-preview.pxw-hat-logo {
        left: 50% !important;
        top: 42% !important;

        width: 25% !important;
        max-width: 185px !important;
        max-height: 155px !important;

        transform:
          translate(-50%, -50%) !important;
      }

      .pswp .pxw-product-logo-preview {
        display: none !important;
      }

      @media screen and (max-width: 640px) {

        [data-pxw-logo-stage] > .pxw-product-logo-preview {

          width: 10% !important;

          max-width: 72px !important;

          max-height: 62px !important;
        }

        [data-pxw-logo-stage] > .pxw-product-logo-preview.pxw-hat-logo {
          left: 50% !important;
          top: 42% !important;

          width: 25% !important;
          max-width: 120px !important;
          max-height: 100px !important;
        }

      }

    `;

    document.head.appendChild(
      style
    );
  }

  /* =========================================================
     REMOVE EXISTING PRODUCT LOGOS
     ========================================================= */

  function removeProductLogoPreviews() {
    document
      .querySelectorAll(
        '.pxw-product-logo-preview'
      )
      .forEach(function(preview) {
        preview.remove();
      });
  }

  /* =========================================================
     PRODUCT IMAGE HELPERS
     ========================================================= */

  function getProductImageIdentity(stage, productImage) {
    var parts = [];

    function add(value) {
      if (value) {
        parts.push(String(value));
      }
    }

    if (productImage) {
      add(productImage.currentSrc);
      add(productImage.src);
      add(productImage.alt);
      add(productImage.title);

      add(productImage.getAttribute('data-src'));
      add(productImage.getAttribute('data-original-src'));
      add(productImage.getAttribute('data-zoom'));
      add(productImage.getAttribute('data-zoom-src'));
      add(productImage.getAttribute('srcset'));

      var imageLink =
        productImage.closest('a');

      if (imageLink) {
        add(imageLink.href);
      }
    }

    if (stage) {
      add(stage.getAttribute('data-media-id'));
      add(stage.getAttribute('data-image-id'));
      add(stage.getAttribute('data-alt'));
      add(stage.getAttribute('aria-label'));
    }

    return parts
      .join(' ')
      .toLowerCase()
      .replace(/%20/g, ' ')
      .replace(/[_-]+/g, ' ');
  }

  function getPXWProductContext() {
    var parts = [
      window.location.pathname || '',
      document.title || ''
    ];

    var title =
      document.querySelector(
        'h1, .product-meta__title, .product__title, [data-product-title]'
      );

    if (title) {
      parts.push(
        title.textContent || ''
      );
    }

    var breadcrumb =
      document.querySelector(
        '.breadcrumb, .breadcrumb__list, nav[aria-label="Breadcrumb"]'
      );

    if (breadcrumb) {
      parts.push(
        breadcrumb.textContent || ''
      );
    }

    return parts
      .join(' ')
      .toLowerCase()
      .replace(/[_-]+/g, ' ');
  }

  function getPXWProductType() {
    var context =
      getPXWProductContext();

    var hatPattern =
      /\b(hat|cap|caps|beanie|beanies|visor|visors|snapback|trucker|bucket hat|headwear)\b/i;

    if (
      hatPattern.test(
        context
      )
    ) {
      return 'hat';
    }

    var excludedPattern =
      /\b(backpack|backpacks|bag|bags|duffel|duffels|tote|totes|briefcase|briefcases|cooler|coolers|cinch|drawstring|luggage|pack|packs|gym bag|sports bag|messenger|towel|towels|blanket|blankets|apron|aprons|chef|tablecloth|table cover|accessory|accessories)\b/i;

    if (
      excludedPattern.test(
        context
      )
    ) {
      return 'excluded';
    }

    var apparelPattern =
      /\b(polo|polos|shirt|shirts|t shirt|tshirt|tee|tees|button down|dress shirt|hoodie|hoodies|sweatshirt|sweatshirts|jacket|jackets|fleece|vest|vests|sweater|sweaters|pullover|pullovers|quarter zip|quarterzip|cardigan|coat|coats|parka|parkas|windbreaker|rain jacket|soft shell|softshell|shell jacket|workwear|scrub|scrubs|lab coat|jersey|tank|tanks|apparel)\b/i;

    if (
      apparelPattern.test(
        context
      )
    ) {
      return 'apparel';
    }

    return 'excluded';
  }

  function looksLikePersonImage(productImage) {
    return new Promise(function(resolve) {
      if (
        !productImage ||
        !productImage.complete ||
        !productImage.naturalWidth
      ) {
        resolve(false);
        return;
      }

      try {
        var canvas =
          document.createElement('canvas');

        var size = 120;

        canvas.width = size;
        canvas.height = size;

        var ctx =
          canvas.getContext(
            '2d',
            { willReadFrequently: true }
          );

        ctx.drawImage(
          productImage,
          0,
          0,
          size,
          size
        );

        var data =
          ctx.getImageData(
            0,
            0,
            size,
            size
          ).data;

        var skinPixels = 0;
        var checkedPixels = 0;

        for (
          var y = 8;
          y < 100;
          y += 2
        ) {
          for (
            var x = 8;
            x < 112;
            x += 2
          ) {
            var i =
              (y * size + x) * 4;

            var r = data[i];
            var g = data[i + 1];
            var b = data[i + 2];
            var a = data[i + 3];

            if (a < 180) {
              continue;
            }

            checkedPixels++;

            var max =
              Math.max(r, g, b);

            var min =
              Math.min(r, g, b);

            var cb =
              128 -
              0.168736 * r -
              0.331264 * g +
              0.5 * b;

            var cr =
              128 +
              0.5 * r -
              0.418688 * g -
              0.081312 * b;

            var skin =
              r > 50 &&
              g > 28 &&
              b > 18 &&
              max - min > 10 &&
              g / Math.max(r, 1) > 0.34 &&
              b / Math.max(r, 1) > 0.16 &&
              cb >= 76 &&
              cb <= 135 &&
              cr >= 132 &&
              cr <= 178;

            if (skin) {
              skinPixels++;
            }
          }
        }

        var ratio =
          checkedPixels
            ? skinPixels /
              checkedPixels
            : 0;

        resolve(
          skinPixels > 32 &&
          ratio > 0.015
        );
      } catch (error) {
        resolve(false);
      }
    });
  }

  async function shouldShowLogoOnStage(
    stage,
    productImage
  ) {
    var identity =
      getProductImageIdentity(
        stage,
        productImage
      );

    var blockedPatterns = [
      /\bmodel\b/i,
      /\bmodelback\b/i,
      /\bmodel back\b/i,
      /\bmannequin\b/i,
      /\blifestyle\b/i,
      /\bwearing\b/i,
      /\bworn\b/i,
      /\bperson\b/i,
      /\bon body\b/i,
      /\bonbody\b/i,
      /\bback\b/i,
      /\brear\b/i,
      /\bside\b/i,
      /\bprofile\b/i
    ];

    for (
      var i = 0;
      i < blockedPatterns.length;
      i++
    ) {
      if (
        blockedPatterns[i].test(
          identity
        )
      ) {
        return false;
      }
    }

    if (
      await looksLikePersonImage(
        productImage
      )
    ) {
      return false;
    }

    return true;
  }

  /* =========================================================
     RENDER LOGO ON PRODUCTS
     ========================================================= */

  async function renderProductLogoPreview(
    logo
  ) {
    installProductPreviewStyles();

    removeProductLogoPreviews();

    if (
      !logo ||
      !logo.file
    ) {
      return;
    }

    var url =
      await prepareProductPreview(
        logo.file
      );

    if (!url) return;

    var stages =
      document.querySelectorAll(
        '[data-pxw-logo-stage]'
      );

    if (!stages.length) {
      return;
    }

    var productType =
      getPXWProductType();

    if (
      productType !== 'apparel' &&
      productType !== 'hat'
    ) {
      return;
    }

    stages.forEach(async function(stage, stageIndex) {

      if (stageIndex === 0) {
        return;
      }

      var productImage =
        stage.querySelector(
          '.product-gallery__image'
        );

      if (!productImage) {
        return;
      }

      if (
        !(await shouldShowLogoOnStage(
          stage,
          productImage
        ))
      ) {
        return;
      }

      var logoImage =
        document.createElement(
          'img'
        );

      logoImage.className =
        'pxw-product-logo-preview';

      if (
        productType === 'hat'
      ) {
        logoImage.classList.add(
          'pxw-hat-logo'
        );
      }

      logoImage.src = url;

      logoImage.alt =
        'Your logo preview';

      logoImage.setAttribute(
        'data-pxw-product-logo-preview',
        ''
      );

      logoImage.setAttribute(
        'aria-hidden',
        'true'
      );

      logoImage.style.position =
        'absolute';

      logoImage.style.width =
        '10%';

      logoImage.style.height =
        'auto';

      logoImage.style.maxWidth =
        '92px';

      logoImage.style.maxHeight =
        '76px';

      logoImage.style.left =
        '64.5%';

      logoImage.style.top =
        '31.5%';

      logoImage.style.right =
        'auto';

      logoImage.style.bottom =
        'auto';

      logoImage.style.transform =
        'translate(-50%, -50%)';

      logoImage.style.objectFit =
        'contain';

      logoImage.style.zIndex =
        '25';

      if (
        productType === 'hat'
      ) {
        logoImage.style.left =
          '50%';

        logoImage.style.top =
          '42%';

        logoImage.style.width =
          '17%';

        logoImage.style.maxWidth =
          '132px';

        logoImage.style.maxHeight =
          '110px';
      }

      stage.appendChild(
        logoImage
      );
    });
  }

  async function refreshProductLogoPreview() {
    try {
      var logo =
        await getLogo();

      await renderProductLogoPreview(
        logo
      );
    } catch (error) {
      console.error(
        'PromoXwear product preview error:',
        error
      );
    }
  }

  /* =========================================================
     GLOBAL REFRESH
     ========================================================= */

  async function refreshGlobalState() {
    try {
      var logo =
        await getLogo();

      updateButtons(
        logo
      );

      await renderProductLogoPreview(
        logo
      );

      document.dispatchEvent(
        new CustomEvent(
          'promox:logo-updated',
          {
            detail: {
              logo: logo
            }
          }
        )
      );
    } catch (error) {
      console.error(
        'PromoXwear logo load error:',
        error
      );
    }
  }

  /* =========================================================
     SAVE BUTTON
     ========================================================= */

  function updateSaveButton() {
    var modal =
      getModal();

    if (!modal) return;

    var saveButton =
      modal.querySelector(
        '[data-pxw-save-logo]'
      );

    var rightsCheckbox =
      modal.querySelector(
        '[data-pxw-logo-rights]'
      );

    if (!saveButton) return;

    saveButton.disabled =
      !(
        selectedFile &&
        rightsCheckbox &&
        rightsCheckbox.checked
      );
  }

  /* =========================================================
     MODAL STATE
     ========================================================= */

  async function refreshModalState() {
    var modal =
      getModal();

    if (!modal) return;

    var previewBox =
      modal.querySelector(
        '[data-pxw-modal-preview]'
      );

    var previewImage =
      modal.querySelector(
        '[data-pxw-modal-preview-image]'
      );

    var savedActions =
      modal.querySelector(
        '[data-pxw-saved-actions]'
      );

    var fileName =
      modal.querySelector(
        '[data-pxw-file-name]'
      );

    var saveButton =
      modal.querySelector(
        '[data-pxw-save-logo]'
      );

    var rightsCheckbox =
      modal.querySelector(
        '[data-pxw-logo-rights]'
      );

    var logo =
      await getLogo();

    if (
      logo &&
      logo.file
    ) {
      if (savedActions) {
        savedActions.hidden =
          false;
      }

      if (fileName) {
        fileName.textContent =
          logo.name ||
          'Saved logo';
      }

      var url =
        makePreview(
          logo.file
        );

      if (
        url &&
        previewImage &&
        previewBox
      ) {
        previewImage.src =
          url;

        previewBox.hidden =
          false;
      } else if (previewBox) {
        previewBox.hidden =
          true;
      }

      if (
        rightsCheckbox &&
        logo.rightsConfirmed
      ) {
        rightsCheckbox.checked =
          true;
      }
    } else {
      if (savedActions) {
        savedActions.hidden =
          true;
      }

      if (!selectedFile) {
        if (previewBox) {
          previewBox.hidden =
            true;
        }

        if (fileName) {
          fileName.textContent =
            '';
        }

        if (rightsCheckbox) {
          rightsCheckbox.checked =
            false;
        }

        if (saveButton) {
          saveButton.disabled =
            true;
        }
      }
    }

    var choiceData = getLogoChoiceData();

    var logoNameInput = modal.querySelector('[data-pxw-logo-name]');
    var orderInput = modal.querySelector('[data-pxw-logo-order]');
    var helpInput = modal.querySelector('[data-pxw-logo-help-note]');
    var onFileSuccess = modal.querySelector('[data-pxw-on-file-success]');
    var helpSuccess = modal.querySelector('[data-pxw-help-success]');

    if (logoNameInput) logoNameInput.value = choiceData.logoName || '';
    if (orderInput) orderInput.value = choiceData.previousOrder || '';
    if (helpInput) helpInput.value = choiceData.helpNote || '';

    if (onFileSuccess) onFileSuccess.hidden = choiceData.choice !== 'on_file';
    if (helpSuccess) helpSuccess.hidden = choiceData.choice !== 'contact';

    setChoicePanelState(
      choiceData.choice === 'on_file' || choiceData.choice === 'contact'
        ? choiceData.choice
        : ''
    );

    syncProductLogoProperties();
    updateSaveButton();
  }

  /* =========================================================
     CLICK EVENTS
     ========================================================= */

  document.addEventListener(
    'click',
    function(event) {

      if (
        event.target.closest(
          '[data-pxw-open-logo]'
        )
      ) {
        event.preventDefault();

        openModal();

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-close-logo]'
        )
      ) {
        event.preventDefault();

        closeModal();

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-change-logo]'
        )
      ) {
        event.preventDefault();

        var input =
          document.querySelector(
            '[data-pxw-logo-file]'
          );

        if (input) {
          input.value = '';

          input.click();
        }

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-remove-logo]'
        )
      ) {
        event.preventDefault();

        removeLogo()
          .then(async function() {

            selectedFile =
              null;

            localStorage.removeItem(
              LOGO_CHOICE_KEY
            );

            clearLogoChoiceDetails();

            dispatchLogoChoice();

            if (productPreviewUrl) {
              URL.revokeObjectURL(
                productPreviewUrl
              );

              productPreviewUrl =
                null;

              productPreviewFile =
                null;

              cleanedPreviewBlob =
                null;
            }

            var modal =
              getModal();

            if (modal) {
              var rightsCheckbox =
                modal.querySelector(
                  '[data-pxw-logo-rights]'
                );

              if (rightsCheckbox) {
                rightsCheckbox.checked =
                  false;
              }

              var previewBox =
                modal.querySelector(
                  '[data-pxw-modal-preview]'
                );

              if (previewBox) {
                previewBox.hidden =
                  true;
              }

              var fileName =
                modal.querySelector(
                  '[data-pxw-file-name]'
                );

              if (fileName) {
                fileName.textContent =
                  '';
              }
            }

            removeProductLogoPreviews();

            refreshGlobalState();

            refreshModalState();
          });

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-logo-on-file]'
        )
      ) {
        event.preventDefault();

        var modalOnFile = getModal();
        if (!modalOnFile) return;

        var onFilePanel =
          modalOnFile.querySelector(
            '[data-pxw-on-file-panel]'
          );

        var shouldOpen =
          !onFilePanel || onFilePanel.hidden;

        setChoicePanelState(
          shouldOpen ? 'on_file' : ''
        );

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-save-on-file]'
        )
      ) {
        event.preventDefault();

        var modalSaveOnFile = getModal();
        if (!modalSaveOnFile) return;

        var logoNameInput =
          modalSaveOnFile.querySelector(
            '[data-pxw-logo-name]'
          );

        var orderInput =
          modalSaveOnFile.querySelector(
            '[data-pxw-logo-order]'
          );

        var success =
          modalSaveOnFile.querySelector(
            '[data-pxw-on-file-success]'
          );

        var logoName =
          logoNameInput
            ? logoNameInput.value.trim()
            : '';

        var previousOrder =
          orderInput
            ? orderInput.value.trim()
            : '';

        if (!logoName) {
          if (logoNameInput) {
            logoNameInput.focus();
            logoNameInput.setAttribute(
              'aria-invalid',
              'true'
            );
          }

          return;
        }

        if (logoNameInput) {
          logoNameInput.removeAttribute(
            'aria-invalid'
          );
        }

        localStorage.setItem(
          LOGO_CHOICE_KEY,
          'on_file'
        );

        localStorage.setItem(
          LOGO_NAME_KEY,
          logoName
        );

        if (previousOrder) {
          localStorage.setItem(
            LOGO_ORDER_KEY,
            previousOrder
          );
        } else {
          localStorage.removeItem(
            LOGO_ORDER_KEY
          );
        }

        localStorage.removeItem(
          LOGO_HELP_KEY
        );

        if (success) {
          success.hidden = false;
        }

        dispatchLogoChoice();

        setTimeout(
          closeModal,
          650
        );

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-logo-help]'
        )
      ) {
        event.preventDefault();

        var modalHelp = getModal();
        if (!modalHelp) return;

        var helpPanel =
          modalHelp.querySelector(
            '[data-pxw-help-panel]'
          );

        var shouldOpenHelp =
          !helpPanel || helpPanel.hidden;

        setChoicePanelState(
          shouldOpenHelp ? 'contact' : ''
        );

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-save-help]'
        )
      ) {
        event.preventDefault();

        var modalSaveHelp = getModal();
        if (!modalSaveHelp) return;

        var helpInput =
          modalSaveHelp.querySelector(
            '[data-pxw-logo-help-note]'
          );

        var helpSuccess =
          modalSaveHelp.querySelector(
            '[data-pxw-help-success]'
          );

        var helpNote =
          helpInput
            ? helpInput.value.trim()
            : '';

        localStorage.setItem(
          LOGO_CHOICE_KEY,
          'contact'
        );

        if (helpNote) {
          localStorage.setItem(
            LOGO_HELP_KEY,
            helpNote
          );
        } else {
          localStorage.removeItem(
            LOGO_HELP_KEY
          );
        }

        localStorage.removeItem(
          LOGO_NAME_KEY
        );

        localStorage.removeItem(
          LOGO_ORDER_KEY
        );

        if (helpSuccess) {
          helpSuccess.hidden = false;
        }

        dispatchLogoChoice();

        setTimeout(
          closeModal,
          650
        );

        return;
      }

      if (
        event.target.closest(
          '[data-pxw-save-logo]'
        )
      ) {
        event.preventDefault();

        var modal =
          getModal();

        if (!modal) return;

        var rightsCheckbox =
          modal.querySelector(
            '[data-pxw-logo-rights]'
          );

        if (
          !selectedFile ||
          !rightsCheckbox ||
          !rightsCheckbox.checked
        ) {
          updateSaveButton();

          return;
        }

        saveLogo(
          selectedFile
        )
          .then(function() {
            if (productPreviewUrl) {
              URL.revokeObjectURL(
                productPreviewUrl
              );

              productPreviewUrl =
                null;
            }

            productPreviewFile =
              null;

            cleanedPreviewBlob =
              null;

            localStorage.setItem(
              LOGO_CHOICE_KEY,
              'uploaded'
            );

            clearLogoChoiceDetails();

            dispatchLogoChoice();

            selectedFile =
              null;

            refreshGlobalState();

            refreshModalState();

            setTimeout(
              closeModal,
              500
            );
          })
          .catch(function(error) {
            console.error(
              'PromoXwear logo save error:',
              error
            );
          });

        return;
      }
    }
  );

  /* =========================================================
     FILE SELECTED
     ========================================================= */

  document.addEventListener(
    'change',
    function(event) {

      if (
        !event.target.matches(
          '[data-pxw-logo-file]'
        )
      ) {
        return;
      }

      var file =
        event.target.files &&
        event.target.files[0];

      if (!file) return;

      selectedFile =
        file;

      var modal =
        getModal();

      if (!modal) return;

      var previewBox =
        modal.querySelector(
          '[data-pxw-modal-preview]'
        );

      var previewImage =
        modal.querySelector(
          '[data-pxw-modal-preview-image]'
        );

      var fileName =
        modal.querySelector(
          '[data-pxw-file-name]'
        );

      var rightsCheckbox =
        modal.querySelector(
          '[data-pxw-logo-rights]'
        );

      if (rightsCheckbox) {
        rightsCheckbox.checked =
          false;
      }

      if (fileName) {
        fileName.textContent =
          file.name;
      }

      if (previewUrl) {
        URL.revokeObjectURL(
          previewUrl
        );

        previewUrl =
          null;
      }

      if (
        file.type !==
        'application/pdf'
      ) {
        previewUrl =
          URL.createObjectURL(
            file
          );

        if (previewImage) {
          previewImage.src =
            previewUrl;
        }

        if (previewBox) {
          previewBox.hidden =
            false;
        }
      } else {
        if (previewBox) {
          previewBox.hidden =
            true;
        }
      }

      updateSaveButton();
    }
  );

  /* =========================================================
     RIGHTS CHECKBOX
     ========================================================= */

  document.addEventListener(
    'change',
    function(event) {

      if (
        !event.target.matches(
          '[data-pxw-logo-rights]'
        )
      ) {
        return;
      }

      updateSaveButton();
    }
  );

  /* =========================================================
     WATCH PRODUCT GALLERY
     ========================================================= */

  function watchProductGallery() {
    return;
  }

  /* =========================================================
     ESCAPE KEY
     ========================================================= */

  document.addEventListener(
    'keydown',
    function(event) {

      if (
        event.key ===
        'Escape'
      ) {
        closeModal();
      }
    }
  );

  /* =========================================================
     INITIALIZE
     ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    function() {
      installProductPreviewStyles();

      refreshGlobalState();

      syncProductLogoProperties();

      dispatchLogoChoice();

      watchProductGallery();
    }
  );

  /* =========================================================
     PUBLIC API
     ========================================================= */

  window.PromoXLogo = {
    getLogo:
      getLogo,

    saveLogo:
      saveLogo,

    removeLogo:
      removeLogo,

    refresh:
      refreshGlobalState,

    refreshProductPreview:
      refreshProductLogoPreview,

    open:
      openModal
  };

})();